import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import service from '../../services/api/supportMirrorService';

export default function SupportMirrorButton({ userId, name, disabled = false }) {
  const { currentUser, isImpersonating } = useContext(AuthContext) || {};
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (currentUser?.userType !== 'support' || isImpersonating || !userId) return null;
  const start = async () => {
    setBusy(true); setError('');
    try { const session = await service.start(userId); navigate(`/support/mirror/${session.id}`); }
    catch (err) { setError(err.response?.data?.error?.message || err.message); }
    finally { setBusy(false); }
  };
  return <span style={{ display: 'inline-block', marginLeft: 8 }}>
    <button type="button" onClick={start} disabled={busy || disabled} aria-label={`Mirror ${name || ''}`.trim()} title="View this user's live Tempus page, cursor and clicks after they agree to share. The user must have Tempus open." style={{ border: '1px solid #176a86', borderRadius: 6, padding: '7px 12px', background: 'white', color: '#176a86', cursor: 'pointer' }}>{busy ? 'Connecting…' : 'Mirror'}</button>
    {error && <span role="alert" style={{ display: 'block', color: '#b91c1c' }}>{error}</span>}
  </span>;
}
